import { Box, Container, Typography, List, ListItem } from '@mui/material';
import CalendarMonthSharp from '@mui/icons-material/CalendarMonthSharp';
import imagePhone from "../../assets/Membership/Instructions/img1.png";

const BrandMembresia = () => {
    const liStyles = {
      display: "flex",
      justifyContent: "flex-start",
      position: "relative",
      width: "100%",
      textAlign: "left",
      padding: "8px 16px",
      alignItems: "baseline",
    };

    const spanStyles = {
      margin: "0px",
      mr: "16px",
      fontSize: {xs:"12px", sm:"20px"},
      lineHeight: "1.5",
      fontWeight: "700",
      color: "rgb(109, 219, 86)",
    }

    const h4Styles = {
      margin: "0px",
      fontSize: {xs:"12px", sm:"20px"},
      lineHeight: "1.235",
      color: "rgb(24, 36, 107)",
      fontWeight: "700",
    }

    return (

      <Box sx={{
        margin: "25px 0",
        width: "100%",
      }}>
        <Container sx={{
          ml: "auto",
          mr: "auto",
          padding: "0 16px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}>

          <Box sx={{
            display: "flex",
            justifyContent: "space-around",
            flexDirection: {xs: "column", sm:"row-reverse"},
          }}>

            <Box sx={{
              width: "100%",
              textAlign: "center",
              alignSelf: "center",
            }}>
              <Typography variant="h2" sx={{
                color: "rgb(6, 199, 249)",
                fontWeight: 700,
                lineHeight: 1.235,
                margin: 0,
                fontSize: {xs: "28px", sm:"34px", md:"32px"},
              }}>
                ¡Utilizar la membresía Salud365 es muy fácil!
              </Typography>

              <List sx={{
                listStyle: "none",
                margin: "0px",
                padding: "8px 0px",
                position: "relative",
                placeItems: "center",
              }}>
                <ListItem sx={liStyles}>
                  <Typography variant="span" sx={spanStyles}>1.</Typography>
                  <Typography variant="h4" sx={h4Styles}>Presenta la tarjeta digital de tu membresía.</Typography>
                </ListItem>

                <ListItem sx={liStyles}>
                  <Typography variant="span" sx={spanStyles}>2.</Typography>
                  <Typography variant="h4" sx={h4Styles}>Presenta una identificación oficial: INE o IFE, pasaporte o licencia.</Typography>
                </ListItem>

                <ListItem sx={liStyles}>
                  <Typography variant="span" sx={spanStyles}>3.</Typography>
                  <Typography variant="h4" sx={h4Styles}>Recibe el servicio solicitado.</Typography>
                </ListItem>
                
                <Box sx={{
                  mt: "20px",
                  backgroundColor: "rgb(6, 199, 249)",
                  textAlign: "center",
                  borderRadius: "8px",
                  width: {xs:"80%"},
                  justifyItems: "center",
                }}>
                  <Typography variant="h5" sx={{
                    margin: "0px",
                    lineHeight: 1.334,
                    fontWeight: 700,
                    color: "rgb(255, 255, 255)",
                    padding: "10px 20px",
                    display: "flex",
                    textAlign: "center",
                    alignItems: "center",
                    fontSize: {xs:"16px"},
                  }}>
                    <CalendarMonthSharp sx={{ mr: "12px"}} />
                    ¡Utilizar la membresía Salud365 es muy fácil!
                  </Typography>
                </Box>
              </List>
            </Box>
            
            <Box sx={{
              maxWidth: "420px",
              alignSelf: "center",
            }}>
              <Box
                component="img"
                src={imagePhone}
                alt="imagen Benefits"
                loading="lazy"
                sx={{
                  objectFit: "contain",
                  mb: "0",
                  height: {xs: "100%"},
                  width: {xs: "100%"}
                }}
              />
            </Box>

          </Box>

        </Container>
      </Box>

    );
};
export default BrandMembresia;
